module.exports = [
  {
    id: 'general',
    title: 'General Limits'
  },
  {
    id: 'kyc-0',
    title: 'Kyc 0 Limits'
  },
  {
    id: 'kyc-1',
    title: 'Kyc 1 Limits'
  },
  {
    id: 'kyc-2',
    title: 'Kyc 2 Limits'
  },
  {
    id: 'kyc-3',
    title: 'Kyc 3 Limits'
  }
];
